<script>
import { h } from 'vue'
import VBTooltip from './VBTooltip'
import elIcon from './elements/elIcon.vue'
// Key codes
const CODE_DOWN = 40
const CODE_END = 35
const CODE_LEFT = 37
const CODE_UP = 38
const CODE_RIGHT = 39
const CODE_HOME = 36
const CODE_SPACE = 32
export default {
  name: 'BTabButton',
  directives: {
    'b-tooltip': VBTooltip
  },
  components: {
    elIcon
  },
  inject: {
    getBvTabs: {
      default: () => () => ({})
    }
  },
  props: {
    controls: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    noKeyNav: {
      type: Boolean,
      default: false
    },
    posInSet: {
      type: Number,
      default: null
    },
    setSize: {
      type: Number,
      default: null
    },
    // Reference to the child <b-tab> instance
    tab: {
      type: undefined,
      default: null
    },
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  emits: ['click', 'first', 'last', 'next', 'prev', 'tabClick'],
  computed: {
    bvTabs() {
      return this.getBvTabs()
    }
  },
  methods: {
    focus() {
      try {
        this.$el.focus()
      } catch (err) {}
    },
    handleEvent(event) {
      if (this.tab.disabled) {
        return
      }
      const { type, keyCode, shiftKey } = event
      if (type === 'click') {
        event.preventDefault()
        event.stopPropagation()
        this.$emit('click', event)
      } else if (type === 'keydown' && keyCode === CODE_SPACE) {
        // For ARIA tabs the SPACE key will also trigger a click/select
        // Even with keyboard navigation disabled, SPACE should "click" the button
        // See: https://github.com/bootstrap-vue/bootstrap-vue/issues/4323
        event.preventDefault()
        event.stopPropagation()
        this.$emit('click', event)
      } else if (type === 'keydown' && !this.noKeyNav) {
        // For keyboard navigation
        if ([CODE_UP, CODE_LEFT, CODE_HOME].indexOf(keyCode) !== -1) {
          event.preventDefault()
          event.stopPropagation()
          if (shiftKey || keyCode === CODE_HOME) {
            this.$emit('first', event)
          } else {
            this.$emit('prev', event)
          }
        } else if ([CODE_DOWN, CODE_RIGHT, CODE_END].indexOf(keyCode) !== -1) {
          event.preventDefault()
          event.stopPropagation()
          if (shiftKey || keyCode === CODE_END) {
            this.$emit('last', event)
          } else {
            this.$emit('next', event)
          }
        }
      }
      if (this.tab?.url) {
        this.$router.push(this.tab.url)
      }
    }
  },
  render() {
    const { tab } = this
    const titleSlot = tab?.$slots?.title && typeof tab.$slots.title === 'function' ? tab.$slots.title() : tab.title
    return h(
      'li',
      {
        class: [
          'nav-item',
          tab.titleItemClass
        ],
        role: 'presentation'
      },
      [
        h(
          'a',
          {
            ref: 'link',
            class: [
              'nav-link',
              {
                active: tab.localActive && !tab.disabled,
                disabled: tab.disabled
              },
              tab.titleLinkClass,
              tab.localActive ? this.bvTabs.activeNavItemClass : null
            ],

            id: this.id,
            href: '#',
            target: '_self',
            role: 'tab',
            'aria-controls': this.controls,
            'aria-selected': tab.localActive && !tab.disabled ? 'true' : 'false',
            'aria-posinset': this.posInSet,
            'aria-disabled': tab.disabled ? 'true' : 'false',
            'aria-setsize': this.setSize,
            tabindex: this.tabIndex,
            onClick: this.handleEvent,
            onKeydown: this.handleEvent
          },
          [titleSlot]
        )
      ]
    )
  }
}
</script>
